import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import { createEpicMiddleware } from 'redux-observable';
import thunk from 'redux-thunk'
import App from './components/App.container';
import {unregister} from './registerServiceWorker';
import { rootEpic, rootReducer } from './reducers/index';
import { fetchGetCountries }  from './reducers/common/location';
import { BrowserRouter as Router, withRouter } from 'react-router-dom'

import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import {changeLanguage, getDefaultLanguage} from "./reducers/common/localization";
// import {fetchGetTranslations} from "./reducers/common/localization";

const epicMiddleware = createEpicMiddleware();

let store = createStore(rootReducer, applyMiddleware(thunk, epicMiddleware));

epicMiddleware.run(rootEpic);

store.dispatch(fetchGetCountries());

// TODO: use it when improve localization in future
// store.dispatch(fetchGetTranslations());
store.dispatch(changeLanguage(getDefaultLanguage()));

let WidgetContainer = withRouter(App);

ReactDOM.render(
    <Provider store={store}>
         <Router>
            <WidgetContainer />
         </Router>
    </Provider>,
    document.getElementById('root')
);
unregister();



// WEBPACK FOOTER //
// ./src/index.js